import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';

import { InicioComponent } from './inicio/inicio.component';
import { DenunciasComponent } from './denuncias/denuncias.component';
import { DenunciasNaoPertinentesComponent } from './denuncias/denuncias-nao-pertinentes.component';
import { DenunciasFinalizadasComponent } from './denuncias/denuncias-finalizadas.component';
import { EntrevistasComponent } from './entrevistas/entrevista.component';
import { ListarEntrevistasComponent } from './listar-entrevistas/listar-entrevistas.component';
import { EntrevistaComponent } from './entrevista/entrevista.component';
import { AtualizarEntrevistaComponent } from './atualizar-entrevista/atualizar-entrevista.component';
import { ResumoComponent } from './resumo/resumo.component';
import { EncaminhamentoComponent } from './encaminhamento/encaminhamento.component';
import { FinalizacaoComponent } from './finalizacao/finalizacao.component';
import { BuscaComponent } from './busca/busca.component';
import { DenunciasdhComponent } from './denunciasdh/denunciasdh.component';
import { SelecaoResponsaveisComponent } from './selecao-responsaveis/selecao-responsaveis.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { EditarUsuariosComponent } from './editar-usuarios/editar-usuarios.component';
import { RemoverUsuariosComponent } from './remover-usuarios/remover-usuarios.component';
import { AdicionarUsuariosComponent } from './adicionar-usuarios/adicionar-usuarios.component';
import { ConfiguracoesComponent } from './configuracoes/configuracoes.component';

import { LoginComponent } from './login/login.component';
import { TokenComponent } from './token/token.component';
import { AuthAndACLGuard } from './auth_and_acl/authAndACL.guard';
import { ValidacaoComponent } from './validacao/validacao.component';

import { AgendamentoComponent } from './agendamento/agendamento.component';
import { ConfirmacaoAgendamentoComponent } from './confirmacao-agendamento/confirmacao-agendamento.component';

import { RelatoriosComponent } from './relatorios/relatorios.component';

/*import { AuthComponent } from './auth/auth.component';*/

const routes: Routes = [
  { path: '#', redirectTo: '/inicio',  pathMatch: 'full' },
  { path: 'inicio',  component: InicioComponent },
  { path: 'busca',  component: BuscaComponent },
  { path: 'denuncias',  component: DenunciasComponent, data: {
      accessRoles: ['Coordenador Geral', 'Coordenador Acolhimento', 'Responsavel Acolhimento', 'Responsavel Geral']
    },canActivate: [AuthAndACLGuard] },
  { path: 'denuncias-nao-pertinentes',  component: DenunciasNaoPertinentesComponent, data: {
      accessRoles: ['Coordenador Geral', 'Coordenador Acolhimento']
  },canActivate: [AuthAndACLGuard] },
  { path: 'denuncias-finalizadas',  component: DenunciasFinalizadasComponent, data: {
      accessRoles: ['Coordenador Geral', 'Coordenador Acolhimento']
  },canActivate: [AuthAndACLGuard] },
  { path: 'relatorios',  component: RelatoriosComponent, data: {
      accessRoles: ['Coordenador Geral', 'Coordenador Acolhimento']
  },canActivate: [AuthAndACLGuard] },
  { path: 'reabrir-entrevista/:id',  component: DenunciasComponent },
  { path: 'entrevista/:id',  component: EntrevistasComponent },
  { path: 'entrevista/:id/:view',  component: EntrevistasComponent },
  { path: 'atentrevista/:id',  component: AtualizarEntrevistaComponent },
  { path: 'dados-entrevista/:id',  component: EntrevistaComponent },
  { path: 'listar-entrevistas/:id',  component: ListarEntrevistasComponent },
  { path: 'resumo/:id', component: ResumoComponent },
  { path: 'encaminhamento/:id/:flag', component: EncaminhamentoComponent },
  { path: 'finalizacao/:id', component: FinalizacaoComponent },
  { path: 'agendamento/:id', component: AgendamentoComponent },
  { path: 'marcacao/:id/:token', component: ConfirmacaoAgendamentoComponent },
  { path: 'desistencia/:id/:token/:flag', component: ConfirmacaoAgendamentoComponent },
  { path: 'teste',  component: EntrevistasComponent },
  //{ path: 'acesso', component: AuthComponent },
  { path: 'denunciasdh', component: DenunciasdhComponent },
  { path: 'selecao-responsaveis', component: SelecaoResponsaveisComponent },
  { path: 'selecao-responsaveis/:id', component: SelecaoResponsaveisComponent, data: {
      accessRoles: ['admin', 'super-admin', 'Coordenador Geral', 'Coordenador Acolhimento']
    },
    canActivate: [AuthAndACLGuard] },
  { path: 'login',  component: LoginComponent },
  { path: 'token/:token/:path', component: TokenComponent },
  { path: 'verificar', component: ValidacaoComponent },
  // { path: 'usuarios', component: UsuariosComponent },
  { path: 'usuarios', component: UsuariosComponent, data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  { path: 'usuarios/editar/:id', component: EditarUsuariosComponent, data: {
    accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  { path: 'usuarios/remover/:id', component: RemoverUsuariosComponent },
  { path: 'usuarios/add', component: AdicionarUsuariosComponent },
  { path: 'configuracoes', component: ConfiguracoesComponent, data: {
      accessRoles: ['Coordenador Geral', 'Coordenador Acolhimento']
    },
    canActivate: [AuthAndACLGuard]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [ AuthAndACLGuard ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts